module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_arrow2-2fda037482b295960f868fd2dd84e187.svg";